import { getters } from '/@/modules/core/app/helpers/store';
import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';

export class MyTeamRouteConfig extends RouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    const user = getters.auth.getUser();
    return user?.permission.canAccessTeams && !user?.hasCurrentEstate;
  }
}
